import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import UnsubscribePage from "@/pages/UnsubscribePage";

export const Route = createFileRoute("/unsubscribe")({
  head: () => pageHead("Unsubscribe | AKIVA", "Unsubscribe from AKIVA newsletter", "/unsubscribe", true),
  component: UnsubscribePage,
});
